import { AppConstant } from "./AppConstant";

export const CategoryEnum = new Map([
  [1, "Tyre"],
  [2, "Wheel"],
  ...(AppConstant.isBatteryShow ? ([[3, "Battery"]] as [number, string][]) : []),
  [4, "Combo"],
]);